import { ReferenceArea, ReferenceAreaRange } from 'bold-ui/lib/components/Chart/model'
import { range } from 'lodash'

import { CategoriaImcColors } from './model-graficoGanhoPeso'

const GANHO_PESO_VALORES_EIXO_X = range(10, 41)
const TEXT_Y_OFF_SET = -11

export function getNotExpectedReferenceArea(
  percentilEixoYValues: ReadonlyArray<number>,
  name: string,
  colors: CategoriaImcColors
): ReferenceArea<number> {
  return {
    area: convertToReferenceAreaRange(percentilEixoYValues),
    name,
    color: colors.unexpectedSurface,
    strokeColor: colors.strokeAndTick,
    tickColor: colors.strokeAndTick,
    textYOffset: TEXT_Y_OFF_SET,
  }
}

export function getUnderExpectedReferenceArea(
  percentilEixoYValues: ReadonlyArray<number>,
  colors: CategoriaImcColors
): ReferenceArea<number> {
  return {
    area: convertToReferenceAreaRange(percentilEixoYValues),
    name: '',
    color: colors.unexpectedSurface,
    strokeColor: colors.strokeAndTick,
    strokeType: 'line',
    tickColor: colors.strokeAndTick,
    textYOffset: TEXT_Y_OFF_SET,
  }
}

export function getExpectedReferenceArea(
  percentilEixoYValues: ReadonlyArray<number>,
  name: string,
  descriptionText: string,
  colors: CategoriaImcColors
): ReferenceArea<number> {
  return {
    area: convertToReferenceAreaRange(percentilEixoYValues),
    name,
    color: colors.expectedSurface,
    strokeColor: colors.strokeAndTick,
    strokeType: 'line',
    tickColor: colors.strokeAndTick,
    description: {
      text: descriptionText,
      color: colors.strokeAndTick,
      style: { fontWeight: 'bold' },
      align: 'bottom',
    },
    textYOffset: TEXT_Y_OFF_SET,
  }
}

export function getEmptyReferenceArea(percentilEixoYValues: ReadonlyArray<number>): ReferenceArea<number> {
  return {
    area: convertToReferenceAreaRange(percentilEixoYValues),
    name: 'Empty',
    color: 'none',
    strokeColor: 'none',
    tickColor: 'none',
  }
}

function convertToReferenceAreaRange(percentilEixoYValues: ReadonlyArray<number>): ReferenceAreaRange<number>[] {
  return percentilEixoYValues.map((y, index) => ({
    x: GANHO_PESO_VALORES_EIXO_X[index],
    upperLimit: y,
  }))
}
